const data = JSON.parse(document.getElementById('data-props').innerHTML);
const coBrand = document.getElementById('data-co-brand').innerHTML;
const deviceType = JSON.parse(
  document.getElementById('data-deviceType').innerHTML
);
const csrf = document.getElementById('data-csrf').innerHTML;
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);

let initialState = {
  states: data.states,
  csrf: csrf,
  data: data,
  coBrand: coBrand,
  deviceType: deviceType,
  donationInfo: data.donationInfo,
  campaignId: data.id,
  categories: data.categories,
  labels: data.labels,
  templateData: data.templateData,
  contributions: data.contributions,
  fptiInfo: fptiInfo,
};

export default function charity(state = initialState, action) {
  // if state is not available, initial state is taken
  return state;
}
